import { render, staticRenderFns } from "./CompanyInsurance.vue?vue&type=template&id=f97778d0"
import script from "./CompanyInsurance.vue?vue&type=script&lang=js"
export * from "./CompanyInsurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports